// extracted by mini-css-extract-plugin
export default {"GiftItem":"GiftItem_GiftItem__J1mo0","activeGift":"GiftItem_activeGift__hkxZ3","GiftImage":"GiftItem_GiftImage__WUyoC","GiftText":"GiftItem_GiftText__hN+xa"};